const markers = document.getElementById("markers");
const template = document.getElementById("person-template");

const generateHtml = (data) => {
  markers.innerHTML = "";
  const keys = Object.keys(data);
  keys.forEach((key, index) => {
    const div = template.content.cloneNode(true);
    div.querySelector("[data-number]").innerHTML = index + 1;
    div.querySelector("[data-name]").innerHTML = data[key].name;
    div.querySelector("[data-specialization]").innerHTML =
      data[key].specialization;
    div.querySelector("[data-achievements]").innerHTML = `<ul>
      <li>${data[key].achievements.join("</li><li>")}</li>
    </ul>`;
    if (data[key].links.video) {
      div.querySelector(
        "[data-links-video]"
      ).innerHTML = `<a href="${data[key].links.video}" target="_blank" rel="nofollow noopener noreferrer">Zobacz wideo</a>`;
    }
    if (data[key].links.bio) {
      div.querySelector(
        "[data-links-bio]"
      ).innerHTML = `<a href="${data[key].links.bio}" target="_blank" rel="nofollow noopener noreferrer">Zobacz biografię</a>`;
    }
    markers.append(div);
  });
};

let activePerson = null;

function initialize() {
  document.querySelectorAll(".person__number").forEach((element, index) => {
    element.addEventListener("click", (event) => {
      if (activePerson && activePerson != event.currentTarget.parentElement) {
        activePerson.classList.remove("active");
      }
      activePerson = event.currentTarget.parentElement;
      activePerson.classList.toggle("active");
      if (!activePerson.classList.contains("active")) {
        activePerson.classList.remove("expanded");
      }
      document.querySelector("body").classList.add("stay");
    });
  });

  document.querySelectorAll(".close-btn").forEach((element, index) => {
    element.addEventListener("click", (event) => {
      activePerson.classList.remove("active");
      document.querySelector("body").classList.remove("stay");
    });
  });

  document
    .querySelectorAll(".person__card__inner__button")
    .forEach((element, index) => {
      element.addEventListener("click", (event) => {
        activePerson.classList.toggle("expanded");
      });
    });

  document.addEventListener("click", (event) => {
    if (activePerson && !activePerson.contains(event.target)) {
      activePerson.classList.remove("active");
      activePerson.classList.remove("expanded");
    }
  });
}

fetch("./mural/data/person.json")
  .then((response) => {
    return response.json();
  })
  .then(function (data) {
    generateHtml(data);
    initialize();
  })
  .catch(function (err) {
    console.warn("Something went wrong.", err);
  });
